export default __webpack_public_path__ + "img/email-open-outline.18a18df3.svg";